import type { FilterDetails, FilterType } from '@typings/search';

const getFilterType = (filter: FilterDetails): FilterType => {
	if (filter.isSingleSelect) return 'facet-single-select';
	return 'facet-multi-select';
};

export const addIdAndTypeToFilters = (
	filters: FilterDetails[],
): FilterDetails[] => {
	return filters.map((filter) => ({
		...filter,
		type: getFilterType(filter),
		id: filter.slug,
	}));
};
